export const FUNNEL_SEARCH_LIMIT = 20;
export const FUNNEL_PHONE_SEARCH_MIN_DIGITS = 3;
export function extractPhoneDigits(raw) {
    return raw.replace(/\D/g, '');
}
export function matchesFunnelSearch(point, query) {
    const trimmed = query.trim();
    if (trimmed === '')
        return false;
    const nameQuery = trimmed.toLocaleLowerCase('ru');
    const name = (point.displayName || '').toLocaleLowerCase('ru');
    if (name.includes(nameQuery))
        return true;
    const phoneDigits = extractPhoneDigits(trimmed);
    if (phoneDigits.length < FUNNEL_PHONE_SEARCH_MIN_DIGITS)
        return false;
    return point.phones.some((phone) => extractPhoneDigits(phone).includes(phoneDigits));
}
export function searchFunnelPoints(points, query, limit = FUNNEL_SEARCH_LIMIT) {
    const trimmed = query.trim();
    if (trimmed === '' || limit <= 0)
        return [];
    const matched = points.filter((point) => matchesFunnelSearch(point, trimmed));
    matched.sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', 'ru'));
    return matched.slice(0, limit);
}
